import React, { useEffect, useState } from "react";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { useFormik, Form, FormikProvider } from "formik";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { useSnackbar } from "notistack";
import {
  getSmeCallStatus,
  getSmeLeads,
  UpdateSmeStatus,
} from "../../../../redux/features/smeSlice";

const CustomTextField = ({
  multiline,
  name,
  label,
  dataRow,
  rows,
  key,
  ...props
}) => (
  <TextField
    name={name}
    label={label}
    value={dataRow[name]}
    // onChange={formik.handleChange}'
    disabled
    fullWidth
    rows={rows}
    multiline
    // error={formik.touched[name] && Boolean(formik.errors[name])}
    // helperText={formik.errors[name]}
    {...props}
  />
);

const SMEstatus = ({ rowData, dispatchdata }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, smeStatus } = useSelector((state) => state.sme);

  const ValidationSchema = Yup.object().shape({
    status: Yup.string().required("Update Status"),
  });

  const getStatusIdFromName = (name) => {
    const match = smeStatus.find(
      (status) => status.sme_call_status_name === name
    );
    return match ? match.sme_call_status_type_id : "";
  };

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      status: getStatusIdFromName(rowData?.sme_call_status),
      remarks: "",
      sme_assignment_id: rowData?.sme_assignment_id,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(UpdateSmeStatus(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getSmeLeads(dispatchdata));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    if (open) {
      dispatch(getSmeCallStatus());
    }
  }, [open]);

  const textFields = [
    { name: "name", label: "Name" },
    { name: "admn_no", label: "Admission Number" },
    { name: "class", label: "Class" },
    { name: "course", label: "Course" },
    { name: "contactNumber", label: "Contact Number" },
    { name: "oga_name", label: "OGA Name" },
    { name: "feepaid", label: "Fee Paid" },
    { name: "book_and_publication", label: "Book & Publication" },
    { name: "assigned_to", label: "Assigned To CRM" },
    { name: "crm_status", label: "CRM Status" },
    { name: "cro_assigned_on", label: "CRO Assigned On" },
    { name: "student_status", label: "Student Status" },
    { name: "sme_call_status", label: "SME Status" },
    { name: "sme_assigned_to", label: "SME Assigned To" },
  ];

  return (
    <GlobalDialog
      title={"Update Lead"}
      open={open}
      setOpen={setOpen}
      fullWidth
      closeButton={true}
      popupButton={
        <UpdateButton size="small" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "status",
                      label: "Status",
                      data: smeStatus,
                      keys: {
                        id: "sme_call_status_type_id",
                        value: "sme_call_status_name",
                      },
                    }}
                  />
                  <TextField
                    fullWidth
                    label="Remarks"
                    name="remarks"
                    multiline
                    rows={2}
                    value={formik.values.remarks}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default SMEstatus;
